import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { BrandingProvider } from '@/context/BrandingContext';
import { ThemeProvider } from '@/context/ThemeContext';

// Suppress ResizeObserver noise (common with recharts/radix popovers, harmless)
const RESIZE_OBS_MSG = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
  if (e && e.message && RESIZE_OBS_MSG.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  if (e && e.reason && String(e.reason).match(RESIZE_OBS_MSG)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);
// Wrap ResizeObserver to defer callbacks (avoids loop error entirely)
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const _RO = window.ResizeObserver;
  window.ResizeObserver = class extends _RO {
    constructor(cb) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try { cb(entries, observer); } catch (e) {}
        });
      });
    }
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrandingProvider><ThemeProvider><App /></ThemeProvider></BrandingProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
